<template>
  <div>
    <div class="uk-grid-small" uk-grid>
      <div class="uk-width-1-1">
        <h3>New Item - {{ item.product_name + ' ' + item.upc }}</h3>
      </div>
      <div class="uk-width-1-1">
        <div class="uk-grid-small" uk-grid>
          <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l">
            <form class="uk-form-horizontal" v-on:submit.prevent="createItem">
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="product" class="uk-form-label">Product</label>
                  <div class="uk-form-controls">
                    <input id="product" type="text" minlength="3" class="uk-input" v-model="product" @keyup="searchProduct" placeholder="Search products" required>
                  </div>
                </div>
              </div>
              <div v-if="products.length > 0" class="uk-margin">
                <div class="uk-inline">
                  <label for="product_id" class="uk-form-label"></label>
                  <div class="uk-form-controls">
                    <select v-model="item.product_id" class="uk-select" name="product_id" id="product_id">
                      <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="upc" class="uk-form-label">UPC</label>
                  <div class="uk-form-controls">
                    <input id="upc" type="text" class="uk-input" v-model="item.upc" placeholder="Enter the UPC" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="sku" class="uk-form-label">SKU</label>
                  <div class="uk-form-controls">
                    <input id="sku" type="text" class="uk-input" v-model="item.sku" placeholder="Enter the SKU" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <label for="price" class="uk-form-label">Price</label>
                  <div class="uk-form-controls">
                    <input id="price" type="text" class="uk-input" v-model="item.price" @change="setPrice" placeholder="Enter the price" required>
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <button class="uk-button uk-button-primary">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "New",
    data() {
      return {
        item: {
          id: null,
          product_id: null,
          product_name: '',
          upc: '',
          sku: null,
          metadata: null,
          price: null,
          new_price: null,
          created_at: null,
          updated_at: null
        },
        products: [],
        product: '',
      }
    },
    methods: {
      async searchProduct() {
        const self = this;

        if (self.product.length <= 3)return;

        self.$request().get(`/search/product?query=${self.product}`)
          .then(r => {
            r = self.$request().successHandler(r).data;

            self.products = r.products;
          });
      },
      setPrice() {
        const self = this;

        self.item.price = parseFloat(self.item.price);
      },
      async createItem() {
        const self = this;

        if (self.item.product_id === null) {
          self.$uikit().notification({
            message: 'Please choose a product',
            status: 'warning',
            position: 'top-center',
            timeout: 3000,
          });
          return;
        }

        self.$request().post('/item', {
          product_id: self.item.product_id,
          upc: self.item.upc,
          sku: self.item.sku,
        }).then(r => {
          r = self.$request().successHandler(r).data;

          self.$request().post(`/item/${r.id}/price`, {
            value: self.item.price
          }).then(r => {
            self.$uikit().notification({
              message: 'The product was successfully created.',
              status: 'success',
              position: 'top-right',
              timeout: 2500,
            });
            setTimeout(function(){
              self.$router.back();
            }, 2500);
          });
        }).catch(e => {
          self.$uikit().notification({
            message: 'Something went wrong! Please try again later.',
            status: 'warning',
            position: 'top-right',
            timeout: 4000,
          })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/item/New.vue